import Vue from 'vue'
import Router from 'vue-router'
import LoginOne from '../components/login/loginOne.vue'
import Login from '../components/login/login.vue'
import Mobile from '../components/login/mobile.vue'
import Amend from '../components/login/amend.vue'
import Security from '../components/login/security.vue'
import Homet from '../components/homet/home/home.vue'
import Select from '../components/homet/make/select.vue'
import Single from '../components/homet/make/single.vue'
import Layout from '../components/homet/layout/index.vue'
import HuiQuestion from '../components/homet/huiquestion/huiquestion.vue'
import Mine from '../components/homet/mine/index.vue'
import Exercise from '../components/homet/mine/exercise.vue'
import ExerciseAdd from '../components/homet/mine/exerciseAdd.vue'
import Wrong from '../components/homet/wrong/index.vue'
import WrongDetails from '../components/homet/wrong/details.vue'
import Analyse from '../components/homet/analyse/index.vue'
import AnalyseDeatil from '../components/homet/analyse/deatil.vue'
import AnalyseGeneral from '../components/homet/analyse/general.vue'
import AnalyseDeatils from '../components/homet/analyse/deatils.vue'
import Perform from '../components/homet/perform/index.vue'
import PerformDeatil from '../components/homet/perform/deatil.vue'
import Sent from '../components/homet/sent/index.vue'
import SentDeatil from '../components/homet/sent/deatil.vue'
import Correct from '../components/homet/correct/index.vue'
import Topic from '../components/homet/correct/topic.vue'
import Pupil from '../components/homet/correct/pupil.vue'
import News from '../components/homet/news/index.vue'
import Rest from '../components/homet/news/rest.vue'
import NewsError from '../components/homet/news/error.vue'
import Student from '../components/homet/news/student.vue'
import User from '../components/homet/user/index.vue'
import Setting from '../components/homet/user/setting.vue'
import Homes from '../components/homes/home/index.vue'
import Stay from '../components/homes/stay/index.vue'
import StayAnswer from '../components/homes/stay/answer.vue'
import Already from '../components/homes/already/index.vue'
import AlreadyDeatil from '../components/homes/already/deatil.vue'
import Users from '../components/homes/user/index.vue'
import NewsSt from '../components/homes/news/index.vue'
import Settings from '../components/homes/user/setting.vue'
import Students from '../components/homes/news/student.vue'
import Rests from '../components/homes/news/rest.vue'
import Errors from '../components/homes/news/error.vue'
import Mistakes from '../components/homes/errors/index.vue'
import Deatilm from '../components/homes/errors/deatil.vue'
import Correcte from '../components/homes/errors/correct.vue'
import Mistake from '../components/homet/mistake/index.vue'
import Mistaked from '../components/homet/mistake/details.vue'
import Reviseexercises from "../components/homet/reviseexercises/Reviseexercises.vue"
import NewExercises from '../components/homet/exercises/index.vue'
import NewAdd from '../components/homet/exercises/addnew.vue'
import AnswerSheet from '../components/homet/answer_sheet/index.vue'
import AnswerSheets from '../components/homes/stay/answer_sheet.vue'
import MistakesSheet from '../components/homes/errors/answer_sheet.vue'
import DeatilSheet from '../components/homes/already/deatil_sheet.vue'
import SentSheet from '../components/homet/sent/sentSheet.vue'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		console.log(err)
	})
}

const router = new Router({
	routes: [{
		path: '/',
		redirect: '/LoginOne'
	},
		{ //修改习题
			path: '/Reviseexercises',
			name: 'Reviseexercises',
			component: Reviseexercises
		},
		{
			path: '/LoginOne',
			name: 'LoginOne',
			component: LoginOne
		},
		{
			path: '/Login',
			name: 'Login',
			component: Login
		},
		{
			path: '/Mobile',
			name: 'Mobile',
			component: Mobile
		},
		{
			path: '/Amend',
			name: 'Amend',
			component: Amend
		},
		{
			path: '/Security',
			name: 'Security',
			component: Security
		},
		{
			path: '/Homet',
			name: 'Homet',
			component: Homet
		},
		{
			path: '/Select',
			name: 'Select',
			component: Select
		},
		{
			path: '/Single',
			name: 'Single',
			component: Single
		},
		{
			path: '/Layout',
			name: 'Layout',
			component: Layout
		},
		{
			path: '/Mine',
			name: 'Mine',
			component: Mine
		},
		{
			path: '/HuiQuestion',
			name: 'HuiQuestion',
			component: HuiQuestion
		},
		{
			path: '/Exercise',
			name: 'Exercise',
			component: Exercise
		},
		{
			path: '/ExerciseAdd/:type',
			name: 'ExerciseAdd',
			component: ExerciseAdd
		},
		{
			path: '/Wrong',
			name: 'Wrong',
			component: Wrong
		},
		{
			path: '/WrongDetails',
			name: 'WrongDetails',
			component: WrongDetails
		},
		{
			path: '/Analyse',
			name: 'Analyse',
			component: Analyse,
		},
		{
			path: '/AnalyseDeatil',
			name: 'AnalyseDeatil',
			component: AnalyseDeatil,
		},
		{
			path: '/AnalyseGeneral',
			name: 'AnalyseGeneral',
			component: AnalyseGeneral,
		},
		{
			path: '/AnalyseDeatils',
			name: 'AnalyseDeatils',
			component: AnalyseDeatils,
		},
		{
			path: '/Perform',
			name: 'Perform',
			component: Perform,
		},
		{
			path: '/PerformDeatil',
			name: 'PerformDeatil',
			component: PerformDeatil,
		},
		{
			path: '/Sent',
			name: 'Sent',
			component: Sent,
		},
		{
			path: '/SentDeatil',
			name: 'SentDeatil',
			component: SentDeatil,
		},
		{
			path: '/Correct',
			name: 'Correct',
			component: Correct,
		},
		{
			path: '/Topic',
			name: 'Topic',
			component: Topic,
		},
		{
			path: '/Pupil',
			name: 'Pupil',
			component: Pupil,
		},
		{
			path: '/News',
			name: 'News',
			component: News,
		},
		{
			path: '/Rest',
			name: 'Rest',
			component: Rest,
		},
		{
			path: '/NewsError',
			name: 'NewsError',
			component: NewsError,
		},
		{
			path: '/Student',
			name: 'Student',
			component: Student,
		},
		{
			path: '/User',
			name: 'User',
			component: User,
		},
		{
			path: '/Setting',
			name: 'Setting',
			component: Setting,
		},
		{
			path: '/SentSheet',
			name: 'SentSheet',
			component: SentSheet,
		},
		{
			path: '/NewExercises',
			name: 'NewExercises',
			component: NewExercises,
		},
		{
			path: '/NewAdd',
			name: 'NewAdd',
			component: NewAdd,
		},
		{
			path: '/AnswerSheet',
			name: 'AnswerSheet',
			component: AnswerSheet,
		},

		// 学生
		{
			path: '/Homes',
			name: 'Homes',
			component: Homes,
		},
		{
			path: '/Stay',
			name: 'Stay',
			component: Stay,
		},
		{
			path: '/AnswerSheets',
			name: 'AnswerSheets',
			component: AnswerSheets,
		},

		{
			path: '/StayAnswer',
			name: 'StayAnswer',
			component: StayAnswer,
		},
		{
			path: '/Already',
			name: 'Already',
			component: Already,
		},
		{
			path: '/AlreadyDeatil',
			name: 'AlreadyDeatil',
			component: AlreadyDeatil,
		},
		{
			path: '/DeatilSheet',
			name: 'DeatilSheet',
			component: DeatilSheet,
		},

		{
			path: '/Users',
			name: 'Users',
			component: Users,
		},
		{
			path: '/Settings',
			name: 'Settings',
			component: Settings,
		},
		{
			path: '/NewsSt',
			name: 'NewsSt',
			component: NewsSt,
		},
		{
			path: '/Students',
			name: 'Students',
			component: Students,
		},
		{
			path: '/Rests',
			name: 'Rests',
			component: Rests,
		},
		{
			path: '/Errors',
			name: 'Errors',
			component: Errors,
		},
		{
			path: '/Mistakes',
			name: 'Mistakes',
			component: Mistakes,
		},
		{
			path: '/MistakesSheet',
			name: 'MistakesSheet',
			component: MistakesSheet,
		},

		{
			path: '/Deatilm',
			name: 'Deatilm',
			component: Deatilm,
		},
		{
			path: '/Correcte',
			name: 'Correcte',
			component: Correcte,
		},
		{
			path: '/Mistake',
			name: 'Mistake',
			component: Mistake,
		},
		{
			path: '/Mistaked',
			name: 'Mistaked',
			component: Mistaked,
		},
		{
			path: '*',
			redirect: '/LoginOne'
		},

	]
})
router.beforeEach(function (to, from, next) {
	next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js